import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import { Grid, Typography } from '@material-ui/core';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { OpposingPartyStyle } from 'containers/PreOpeningPage/OpposingParty/styled-components';
import messages from 'containers/PreOpeningPage/messages';
import { translate } from 'containers/services/translate';
import { FormContainer } from 'containers/PreOpeningPage/OpposingParty/styled-components';
import SahamAccordion from 'components/SahamAccordion';
import OpposingPartyForm from 'containers/PreOpeningPage/OpposingParty/OpposingPartyForm';
import { Listings } from 'containers/AppContainer/typings';
import {
  getLabels,
  isVehiculeIncludedInJudiciarySteps,
} from 'containers/PreOpeningPage/OpposingParty/utils';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { isClaimPendingClaim } from 'containers/RecapManagerPage/utils';
import DecisionPartiesDialog from 'containers/PreOpeningPage/DecisionPartiesDialog';
import { PARTIES_CLAIM_STATUS } from 'containers/data-structure';
import { renderStatusDecisionParties } from 'containers/PreOpeningPage/utils';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';

export interface OpposingPartyRecapComponentProps {
  intl: IntlShape;
  vehicule: Vehicule;
  index: number;
  isManager?: boolean;
  handleToggleDrawer: Function;
  setCurrentVehicule: Function;
  listings: Listings;
  claim: any;
  policyInfo?: any;
  requestValidateVehicle?: Function;
  isLawyer?: boolean;
  isRejected?: boolean;
  handleDeleteOpposingParty?: Function;
  isCourtManager?: boolean;
  sagisOpposingParties: any;
  isPending?: boolean;
  isValidated?: boolean;
  isConsultation?: boolean;
  isValidatedCorpo?: boolean;
}

const OpposingPartyRecapComponent: React.FC<OpposingPartyRecapComponentProps> = ({
  vehicule,
  handleToggleDrawer,
  setCurrentVehicule,
  isManager,
  index,
  listings,
  claim,
  ...props
}): JSX.Element => {
  const [expanded, setExpanded] = React.useState<boolean>(true);
  const [openDecisionDialog, setOpenDecisionDialog] = React.useState<boolean>(
    false,
  );
  const [selectedVehicle, setSelectedVehicle] = React.useState<any>({});

  const handleClick = (event: React.ChangeEvent<{}>, expanded: boolean) => {
    setExpanded(expanded);
  };

  const handleEdit = () => {
    handleToggleDrawer && handleToggleDrawer();
    setCurrentVehicule && setCurrentVehicule(vehicule);
  };
  const handleOpenDecisionDialog = (vehicle: any) => {
    setOpenDecisionDialog(true);
    setSelectedVehicle(vehicle);
  };
  const isManagerOpeningManager =
    userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER) &&
    userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER);
  return (
    <OpposingPartyStyle>
      <SahamAccordion
        title={translate(messages.opposingParty, props, {
          number: index + 1,
        })}
        expanded={expanded}
        onChange={handleClick}
        accordionDetailsClassName="collapse-recap"
        editButtonTitle={
          isManagerOpeningManager
            ? get(vehicule, 'decision.status', '') ===
              PARTIES_CLAIM_STATUS.PENDING
              ? translate({ ...messages.decisionButtonTitle }, props)
              : (isClaimPendingClaim(claim) &&
                  isManager &&
                  !props.isConsultation &&
                  !props.isValidatedCorpo) ||
                (userPrivileges.userHasPrivilege(
                  PRIVILEGES.ISCOURTMONITORINGMANAGER,
                ) &&
                  !props.isConsultation &&
                  !props.isValidatedCorpo)
              ? translate({ ...messages.updateBtnLabel }, props)
              : undefined
            : (isClaimPendingClaim(claim) &&
                isManager &&
                !props.isConsultation &&
                !props.isValidatedCorpo) ||
              (userPrivileges.userHasPrivilege(
                PRIVILEGES.ISCOURTMONITORINGMANAGER,
              ) &&
                !props.isConsultation &&
                !props.isValidatedCorpo) ||
              (userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) &&
                get(vehicule, 'id') &&
                ((featureService.hasFeature(
                  FEATURES.UPDATE_CLAIM_OPENING_MANAGER,
                ) &&
                  props.isPending &&
                  !props.isValidatedCorpo &&
                  !props.isConsultation) ||
                  (featureService.hasFeature(
                    FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
                  ) &&
                    props.isValidated &&
                    !props.isConsultation))) ||
              (props.isLawyer &&
                props.isRejected &&
                !props.isValidatedCorpo &&
                get(vehicule, 'id') &&
                !props.isConsultation) ||
              (props.isCourtManager &&
                !props.isConsultation &&
                !props.isValidatedCorpo &&
                get(vehicule, 'id') &&
                featureService.hasFeature(FEATURES.UPDATE_CLAIM_COURT_MANAGER))
            ? translate({ ...messages.updateBtnLabel }, props)
            : undefined
        }
        deleteButtonTitle={
          (props.isLawyer && props.isRejected && !props.isValidatedCorpo) ||
          (props.isCourtManager &&
            !props.isValidatedCorpo &&
            get(vehicule, 'id') &&
            featureService.hasFeature(FEATURES.UPDATE_CLAIM_COURT_MANAGER)) ||
          (userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER) &&
            !isVehiculeIncludedInJudiciarySteps(vehicule) &&
            ((featureService.hasFeature(
              FEATURES.UPDATE_CLAIM_OPENING_MANAGER,
            ) &&
              props.isPending) ||
              (featureService.hasFeature(
                FEATURES.UPDATE_VALIDATED_CLAIM_OPENING_MANAGER,
              ) &&
                props.isValidated)) &&
            !props.isValidatedCorpo)
            ? translate({ ...messages.vehicleDeleteButtonTitle }, props)
            : undefined
        }
        deleteButtonOnClick={
          (props.isLawyer && props.isRejected) ||
          (props.isCourtManager &&
            get(vehicule, 'id') &&
            featureService.hasFeature(FEATURES.UPDATE_CLAIM_COURT_MANAGER)) ||
          userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER)
            ? props.handleDeleteOpposingParty &&
              props.handleDeleteOpposingParty(vehicule)
            : undefined
        }
        editButtonOnClick={
          isManagerOpeningManager &&
          get(vehicule, 'decision.status', '') === PARTIES_CLAIM_STATUS.PENDING
            ? () => handleOpenDecisionDialog(vehicule)
            : handleEdit
        }
      >
        <>
          <FormContainer>
            <OpposingPartyForm
              vehicule={{
                ...vehicule,
                ...(getLabels(listings, vehicule) as Vehicule),
              }}
              customClass="formEl"
              readOnly
              listings={listings}
              isForDrawer={false}
              sagisOpposingParties={props.sagisOpposingParties}
            />
          </FormContainer>
          {get(vehicule, 'decision.status', '') ===
          PARTIES_CLAIM_STATUS.REJECTED ? (
            <Grid container direction="row" spacing={3}>
              <Grid item>
                <Typography
                  style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#0072c6',
                  }}
                >
                  {translate(messages.statusRecapTitle, props)}
                </Typography>
              </Grid>
              <Grid item>
                <Typography style={{ fontSize: '14px', color: 'red' }}>
                  {renderStatusDecisionParties(
                    get(vehicule, 'decision.status', ''),
                  )}
                </Typography>
              </Grid>
              <Grid item>
                <Typography
                  style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    color: '#0072c6',
                  }}
                >
                  {translate(messages.reasonRecapTitle, props)}
                </Typography>
              </Grid>
              <Grid item>
                <Typography style={{ fontSize: '14px', color: 'red' }}>
                  {get(vehicule, 'decision.reason', '')}
                </Typography>
              </Grid>
            </Grid>
          ) : (
            <>
              {get(vehicule, 'decision.reason', '') && (
                <Grid container direction="row" spacing={3}>
                  <Grid item>
                    <Typography
                      style={{
                        fontSize: '14px',
                        fontWeight: 'bold',
                        color: '#0072c6',
                      }}
                    >
                      {translate(messages.reasonRecapTitle, props)}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography style={{ fontSize: '14px', color: 'black' }}>
                      {get(vehicule, 'decision.reason', '')}
                    </Typography>
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </>
      </SahamAccordion>
      {openDecisionDialog && (
        <DecisionPartiesDialog
          open={openDecisionDialog}
          onClose={() => {
            setOpenDecisionDialog(false);
            setSelectedVehicle({});
          }}
          policyInfo={props.policyInfo}
          parties={selectedVehicle}
          requestValidateVehicle={props.requestValidateVehicle}
          isVehicle
        />
      )}
    </OpposingPartyStyle>
  );
};

export default injectIntl(OpposingPartyRecapComponent);
